import { TableCell } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledCell = styled(TableCell)({
  fontSize: "1.6rem",
});

export default StyledCell;
